import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetRequiredInfoResponse } from './types';
import { PostErrorResponse } from '../post';

export const getRequiredInfo = async (lang = 'en') => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/signin/required-info?${queryParams.join('&')}`, {
		method: 'GET',
		credentials: 'include',
	})
		.then((res) => {
			if (res.ok) return res.json() as Promise<GetRequiredInfoResponse>;
			return res.json().then(errorResponse => {
				throw errorResponse as PostErrorResponse
			});

		})
		.catch((error) => {
			console.error('Profile request error: ', error);
			throw error;
		});
};
